<template>
  <div>
    <div class="row m-0 border sticky">
      <h2 class="col-md-12 p-3">Legend</h2>
      <div class="col-sm-4 mb-3" v-for="(output, key, index) in outputs" :key="output.name">
          <label :for="output.name" v-html="output.name"/>:
          <span :name="output.name" v-html="output.label"/>
      </div>
    </div><br>
    <div class="row">
      <div class="col-md-12">
        <h1>Raw Values</h1>
        <form id="search">
            <label for="query">Search</label>
            <input name="query" v-model="searchQuery" placeholder="Company or Year">
        </form>
        <div class="dataviewer">
            <GridView :data="gridData" :columns="gridColumns" :filter-key="searchQuery"></GridView>
        </div>
      </div>
    </div><br>
    <div class="row">
      <div class="col-md-12">
        <h1>Normalized Values</h1>
        <form id="search">
            <label for="query">Search</label>
            <input name="query" v-model="searchQuery2" placeholder="Company or Year">
        </form>
        <div class="dataviewer">
            <GridView :data="gridData2" :columns="gridColumns2" :filter-key="searchQuery2"></GridView>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <Chart/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .dataviewer {
      max-width: 100%;
      max-height: 500px;
      overflow: auto;
  }

  input, select {
  	display: inline-block;
  	background-color: #fff;
  	color: #888;
  	border: 2px solid rgba(0,0,0,.2);
  	border-radius: 2px;
  	height: 56px;
  	width: 100%;
  	font-size: 24px;
  	padding: 0 16px;
  	margin-bottom: 24px;
  }

  input:focus {
      border: 3px solid rgba(0,0,0,.6);
  }
</style>

<script>
  import GridView from '@/components/GridView.vue';
  import Chart from '@/components/Chart.vue';

  export default {
    name: 'data',
    components: {
      GridView,
      Chart
    },
    data() {
      return {
        searchQuery: '',
        searchQuery2: '',
        gridColumns: ['Company', 'Year', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6', 'V7', 'V8'],
        gridColumns2: ['Company', 'Year', 'V1\'', 'V2\'', 'V3\'', 'V4\'', 'V5\'', 'V6\'', 'V7\'', 'V8\'', 'IMVM'],
        gridData: [],
        gridData2: [],
        outputs: [
          {
            "key": "V1",
            "name": "V<sub>1</sub>",
            "label": "Market Share (%)"
          },
          {
            "key": "V2",
            "name": "V<sub>2</sub>",
            "label": "Cash Flow Margin (%)"
          },
          {
            "key": "V3",
            "name": "V<sub>3</sub>",
            "label": "Continuity ($)"
          },
          {
            "key": "V4",
            "name": "V<sub>4</sub>",
            "label": "Conception ($)"
          },
          {
            "key": "V5",
            "name": "V<sub>5</sub>",
            "label": "Inventory Turnover"
          },
          {
            "key": "V6",
            "name": "V<sub>6</sub>",
            "label": "Water Consumption per vehicle produced (m<sup>3</sup>/#)"
          },
          {
            "key": "V7",
            "name": "V<sub>7</sub>",
            "label": "Energy Consumption per vehicle produced (MWh/#)"
          },
          {
            "key": "V8",
            "name": "V<sub>8</sub>",
            "label": "CO<sub>2</sub> Emission per vehicle produced (t/#)"
          },
          {
            "key": "IMVM",
            "name": "I<sub>MVM</sub>",
            "label": "Index for Motor Vehicle Manufacturors"
          }
        ],
      }
    },
    mounted: function(){
        this.getAllRawData();
        this.getAllNormData();
    },
    methods:{
        getAllRawData: function(){
            let myself = this;
            this.axios.get("https://cpi.mvm.tudelft.nl/php/api.php?action=allRaw").then(function(response){
                // let response = [{"Brand Name":"Toyota","Year":2008,"Profit\/E":-21336.842,"Inventory Turnover":-12.025,"R&D Expenditure":16187,"Water Consumption":4.013,"Energy Consumption":2.751,"CO2 Emission":0.557,"Market Capitalization":94399.215,"Market Share":0.144,"Cash Flow Margin":0.061},{"Brand Name":"Toyota","Year":2009,"Profit\/E":5777.566,"Inventory Turnover":-11.078,"R&D Expenditure":21934.142,"Water Consumption":3.868,"Energy Consumption":3.163,"CO2 Emission":0.815,"Market Capitalization":175806.662,"Market Share":0.079,"Cash Flow Margin":0.159}];
                // self.gridData = response;
                myself.gridData = response.data;
            });
        },
        getAllNormData: function(){
            let myself = this;
            this.axios.get("https://cpi.mvm.tudelft.nl/php/api.php?action=allNorm").then(function(response){
                // let response = [{"Brand Name":"Toyota","Year":2008,"Profit\/E":-21336.842,"Inventory Turnover":-12.025,"R&D Expenditure":16187,"Water Consumption":4.013,"Energy Consumption":2.751,"CO2 Emission":0.557,"Market Capitalization":94399.215,"Market Share":0.144,"Cash Flow Margin":0.061},{"Brand Name":"Toyota","Year":2009,"Profit\/E":5777.566,"Inventory Turnover":-11.078,"R&D Expenditure":21934.142,"Water Consumption":3.868,"Energy Consumption":3.163,"CO2 Emission":0.815,"Market Capitalization":175806.662,"Market Share":0.079,"Cash Flow Margin":0.159}];
                // self.gridData = response;
                myself.gridData2 = response.data;
            });
        }
    }
  }
</script>
